<template>
  <div>
    <b-card title="Düzenle">
      <validation-observer ref="simpleRules">
        <warehouse-form />
      </validation-observer>
    </b-card>
    <div class="text-left">
      <b-button
        variant="primary"
        class="text-left"
        :disabled="dataItem.submitStatus"
        @click="submitData"
      >
        Kaydet
      </b-button>
    </div>
  </div>
</template>
<script>
import { BButton, BCard } from 'bootstrap-vue'
import WarehouseForm from '@/views/Admin/Warehouses/Components/WarehouseForm.vue'
import { ValidationObserver, localize } from 'vee-validate'

// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'EditCard',
  components: {
    BButton,
    WarehouseForm,
    BCard,
    ValidationObserver,
  },
  computed: {
    dataItem() {
      return this.$store.getters['warehouses/dataItem']
    },
    saveData() {
      return this.$store.getters['warehouses/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.dataItem.submitStatus = false
        this.$router.push({ name: 'Warehouses' })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },

  methods: {
    submitData() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.submitStatus = true
          this.$store.dispatch('warehouses/saveData', this.dataItem)
        } else {
          this.showToast({
            variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: 'Bütün alanları doldurmalısınız.',
          })
        }
      })
    },
    getDataItem() {
      this.$store.dispatch('warehouses/getDataItem', this.$route.params.id)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
